import { Project } from "../types/data";

export default [
    {
        key: "magnetism",
        image: "magnetism.png",
        link: "/project/magnetism",
        category: "minecraft",
        technologies: [
            "MCFunction"
        ]
    },
    {
        key: "90gqopen",
        image: "90gqopen.png",
        link: "/project/90gqopen-website",
        category: "websites",
        technologies: [
            "TypeScript",
            "Next.js",
            "Tebex.js"
        ]
    },
    {
        key: "portfolio",
        image: "portfolio.png",
        link: "https://github.com/EdvinLjungqvist/edvinljungqvist.github.io",
        category: "websites",
        technologies: [
            "TypeScript",
            "React.js"
        ]
    },
    {
        key: "humanPerformanceTester",
        image: "human-performance-tester.png",
        link: "https://github.com/EdvinLjungqvist/Human-Performance-Tester",
        category: "websites",
        technologies: [
            "JavaScript",
            "Node.js",
            "React.js"
        ]
    },
    {
        key: "othello",
        image: "othello.png",
        link: "https://github.com/EdvinLjungqvist/Othello",
        category: "games",
        technologies: [
            "Kotlin",
            "Jetpack Compose"
        ]
    },
    {
        key: "quizGame",
        image: "quiz-game.png",
        link: "https://github.com/EdvinLjungqvist/Quiz-Game",
        category: "games",
        technologies: [
            "Java"
        ]
    },
    {
        key: "balloonBlasters",
        image: "balloon-blasters.png",
        link: "https://scalargames.com",
        category: "minecraft",
        technologies: [
            "MCFunction"
        ]
    },
    {
        key: "salmonSays",
        image: "salmon-says.png",
        link: "https://scalargames.com",
        category: "minecraft",
        technologies: [
            "MCFunction"
        ]
    },
    {
        key: "advancedNpc",
        image: "advanced-npc.png",
        link: "https://github.com/EdvinLjungqvist/advanced_npc",
        category: "minecraft",
        technologies: [
            "MCFunction"
        ]
    }
] as Project[];
